import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/lib/DropdownList';
import _ from 'lodash';
import { querySelector } from '../../../utils';

const propTypes = exact({
  onSelectSupervisor: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  selectedSupervisorId: PropTypes.number.isRequired,
  allSupervisors: PropTypes.array,
  showAllSupervisors: PropTypes.bool,
});

const returnSubordinateSupervisorList = (paramAllSupervisors, currentUser) => {
  /* NOTE: finds currently logged user in supervisor list and returns sub supervisors */
  const currentSupervisor = _.find(paramAllSupervisors, { id: currentUser.id });
  const allSubordinateSupervisors = (currentSupervisor) ? currentSupervisor.all_subordinate_supervisors : [];

  return allSubordinateSupervisors;
};

const returnSupervisorList = (paramAllSupervisors) => {
  return _.map(paramAllSupervisors, (user) => {
    return _.omit(user, 'all_subordinate_supervisors');
  });
};

export class SupervisorInput extends Component {
  handleChange(data) {
    this.props.onSelectSupervisor(data.id);
  }

  buildSupervisorList() {
    const { allSupervisors, currentUser, showAllSupervisors } = this.props;

    const currentUserList = [{
      id: currentUser.id,
      name: `${currentUser.firstname} ${currentUser.lastname}`,
    }];

    const supervisorList = (showAllSupervisors)
      ? returnSupervisorList(allSupervisors)
      : returnSubordinateSupervisorList(allSupervisors, currentUser);

    return _.unionBy(currentUserList, supervisorList, 'id');
  }

  render() {
    const { currentUser, selectedSupervisorId } = this.props;
    const allSupervisors = this.buildSupervisorList();

    let supervisorId = selectedSupervisorId;
    if (currentUser && (supervisorId === null || supervisorId === 0)) {
      supervisorId = currentUser.id;
    }

    return (
      <div>
        <DropdownList
          inputProps={{
            className: 'select',
          }}
          data={allSupervisors}
          value={supervisorId}
          valueField="id"
          textField="name"
          onChange={(e) => { this.handleChange(e); }}
        />
      </div>
    );
  }
}

SupervisorInput.propTypes = propTypes;
SupervisorInput.defaultProps = {
  showAllSupervisors: true,
};


export const GetAllSupervisorsQuery = gql`
  query GetAllSupervisors {
    all_supervisors{
     edges {
       node {
         id
         name: fullname
         all_subordinate_supervisors {
           id
           name: fullname
         }
       }
     }
   }
 }
`;

export const marshallData = ({ data, ownProps }) => {
  const allSupervisors = querySelector(data, '$.all_supervisors.edges[*].node', []);
  return {
    ...ownProps,
    allSupervisors,
  };
};

const withData = graphql(GetAllSupervisorsQuery, { props: marshallData });

export default withData(SupervisorInput);
